var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcSell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555597",
    d: "M16 3.758V.016H9.793v3.742h2.496v1.186h-3.68v-3.68H2.525v3.68h-.655C.84 4.944 0 5.783 0 6.814v7.3c0 1.031.84 1.87 1.871 1.87H14.13c1.032 0 1.871-.84 1.871-1.87v-7.3c0-1.031-.84-1.87-1.871-1.87h-.593V3.758H16zM3.774 2.511H7.36v4.803H3.774V2.51zm10.355 12.226H1.87c-.344 0-.623-.28-.623-.624s.28-.624.623-.624H14.13c.344 0 .623.28.623.624s-.28.624-.623.624zm0-8.546c.344 0 .623.28.623.624v5.534c-.195-.07-.405-.107-.623-.107H1.87c-.218 0-.428.038-.623.107V6.815c0-.344.28-.624.623-.624h.655v2.37h6.082v-2.37h5.52zm-3.088-3.68V1.263h3.711v1.248h-3.711z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_sell.3bde5424.svg";
export { ForwardRef as ReactComponent };